(() => {
  const dictionary = {
    it: {
      product: "prodotto",
      products: "prodotti",
      remove: "Rimuovi",
      secure: "Pagamenti sicuri e protetti"
    },
    en: {
      product: "product",
      products: "products",
      remove: "Remove",
      secure: "Secure and protected payments"
    }
  };

  const prepareCartDrawer = () => {
    const drawer = document.querySelector("#CartDrawer.drawer");
    if (!drawer) return;

    const language = document.documentElement.lang?.slice(0, 2) || "it";
    const labels = dictionary[language] || dictionary.it;
    const countElement = drawer.querySelector(".x-cart-item-count");
    const titleGroup = drawer.querySelector(".x-cart-heading > div");
    const count = Number.parseInt(countElement?.textContent || "0", 10);

    if (titleGroup) {
      titleGroup.dataset.rxProductLabel =
        `${Number.isFinite(count) ? count : 0} ${count === 1 ? labels.product : labels.products}`;
    }

    drawer.querySelectorAll(".cart-item__quantity > div > button").forEach((button) => {
      button.dataset.rxRemoveLabel = labels.remove;
      if (!button.getAttribute("aria-label")) button.setAttribute("aria-label", labels.remove);
    });

    const paymentArea = drawer.querySelector(
      ".footer-cart-drawer-mobile > .flex.flex-col > .flex + div"
    );
    if (paymentArea) paymentArea.dataset.rxSecureLabel = labels.secure;
  };

  let scheduled = false;
  const schedulePreparation = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      prepareCartDrawer();
    });
  };

  const observer = new MutationObserver(schedulePreparation);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener("DOMContentLoaded", schedulePreparation);
  document.addEventListener("shopify:section:load", schedulePreparation);
  schedulePreparation();
})();
